export const coverageTypeDefault = ['full-amortization', 'term-insurance'];

export const largeFormFieldMaxChar = 150;

export const marks = [
  {
    value: 1,
    label: '1'
  },
  {
    value: 2,
    label: '2'
  },
  {
    value: 3,
    label: '3'
  },
  {
    value: 4,
    label: '4'
  },
  {
    value: 5,
    label: '5'
  }
];
